import React from 'react';
import { Text, Theme, Services } from '@simplybenefits/sb-ui-library';
import { styled } from '@mui/system';
import { constants } from '@simplybenefits/sb-utils';

const StyledHeaderBar = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    marginTop: 20,
    marginBottom: 10,
    padding: 8,
    backgroundColor: theme.palette.primary.main
}));

const StyledHeaderBarNoFill = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    marginTop: 20,
    marginBottom: 10,
    padding: 8,
    borderTop: `1.5px solid ${ theme.palette.primary.main }`,
    borderBottom: `1.5px solid ${ theme.palette.primary.main }`
}));

/**
 * @param transaction
 * @param classes
 * @returns {*}
 * @constructor
 */
const LTDReport = ({ report, testid }) => {
    const styles = {
        block: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            marginBottom: 20
        },
        row: {
            display: 'flex',
            flex: 1,
            flexDirection: 'row',
            padding: "5px 30px 0 50px"
        },
        rowCondensed: {
            display: 'flex',
            flex: 1,
            flexDirection: 'row',
            padding: "3px 8px"
        }
    };
    return (
        <div style={ styles.block }>
            {
                report.map((items) => (
                    <React.Fragment>
                        <StyledHeaderBar>
                            <Text medium bold color={ Theme.colors.surface } customStyle={{ flex: 1 }}>{ `${ items[0].lastname }, ${ items[0].firstname }` }</Text>
                            <Text medium bold color={ Theme.colors.surface } customStyle={{ flex: 1, textAlign: 'right' }}>Certificate: { items[0].cert }</Text>
                        </StyledHeaderBar>

                        <div style={ styles.rowCondensed }>
                            <Text medium bold customStyle={{ flex: 1 }}>Status</Text>
                            <Text medium bold customStyle={{ flex: 1 }}>Class</Text>
                            <Text medium bold customStyle={{ flex: 1 }}>Division</Text>
                            <Text medium bold customStyle={{ flex: 1 }}>Province</Text>

                            { 
                                items[0].payrollID ?
                                    <Text medium bold customStyle={{ flex: 1 }}>Payroll ID</Text>
                                    :
                                    null
                            }

                        </div>

                        <div style={ styles.rowCondensed }>
                            <Text medium customStyle={{ flex: 1 }}>{ constants.memberStatusMap[items[0].status] }</Text>
                            <Text medium customStyle={{ flex: 1 }}>{ items[0].class }</Text>
                            <Text medium customStyle={{ flex: 1 }}>{ items[0].division }</Text>
                            <Text medium customStyle={{ flex: 1 }}>{ items[0].province }</Text>
                            
                            { 
                                items[0].payrollID ? 
                                    <Text medium customStyle={{ flex: 1 }}>{ items[0].payrollID }</Text>
                                    :
                                    null
                            }
                            
                        </div>

                        <StyledHeaderBarNoFill>
                            <Text medium bold customStyle={{ flex: 1 }}>Effective Date</Text>
                            <Text medium bold customStyle={{ flex: 1, textAlign: 'center' }}>Salary</Text>
                            <Text medium bold customStyle={{ flex: 1, textAlign: 'center' }}>Volume</Text>
                            <Text medium bold customStyle={{ flex: 2, textAlign: 'center' }}>Approved Volume (Grandfathered)</Text>
                            <Text medium bold customStyle={{ flex: 1, textAlign: 'center' }}>Premium</Text>
                        </StyledHeaderBarNoFill>

                        {
                            items.map((item) => (
                                <div style={ styles.rowCondensed }>
                                    <Text medium bold customStyle={{ flex: 1 }}>{ Services.dates.formatIncomingDate(item.effectiveDate) || 'N/A' }</Text>
                                    <Text medium bold customStyle={{ flex: 1, textAlign: 'center' }}>{ item.earnings || 'N/A' }</Text>
                                    <Text medium bold customStyle={{ flex: 1, textAlign: 'center' }}>{ item.volume || 'N/A' }</Text>
                                    <Text medium bold customStyle={{ flex: 2, textAlign: 'center' }}>{ item.approvedVolume || 'N/A' }</Text>
                                    <Text medium bold customStyle={{ flex: 1, textAlign: 'center' }}>{ item.premium || 'N/A' }</Text>
                                </div>
                            ))
                        }
                    </React.Fragment>
                ))
            }

            <span id={testid} />
        </div>
    );
};

export default (LTDReport);